import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BrandLocation } from '@compumark/analyst-selection-tool-client';
import { CustomTextFilterComponent } from '@compumark/brand-context-components';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { GridApi, GridOptions } from 'ag-grid-community';
import { debounceTime, fromEvent } from 'rxjs';
import { FilterParams } from 'src/app/results/services/filters.params';
import { WCLAddOnPopupLinkComponent } from '../wcl-addon-popup-link/wcl-addon-popup-link.component';

@UntilDestroy()
@Component({
  selector: 'app-wcl-locations',
  standalone: false,
  templateUrl: './wcl-locations.component.html',
  styleUrls: ['./wcl-locations.component.scss'],
})
export class WCLLocationsComponent implements OnInit {
  gridApi!: GridApi;
  rowData: BrandLocation[] = [];

  readonly gridOptions: GridOptions = {
    suppressHeaderFocus: true,
    getRowId: (t) => t.data.brandId,
    getRowHeight: () => 35,
    rowModelType: 'clientSide',
    enableCellTextSelection: true,
    suppressHorizontalScroll: false,
    suppressMovableColumns: true,
    suppressCellFocus: true,
    suppressRowClickSelection: true,
    detailRowAutoHeight: true,
    overlayLoadingTemplate: '<span></span>',

    columnDefs: [
      {
        headerName: 'Brand Id',
        field: 'brandId',
        filter: 'textColumnFilterWithoutOptions',
        filterParams: FilterParams.textFilterParams,
        menuTabs: ['filterMenuTab'],
        width: 120,
      },
      {
        headerName: 'Brand Description',
        field: 'brandDescription',
        filter: 'textColumnFilterWithoutOptions',
        menuTabs: ['filterMenuTab'],
        filterParams: FilterParams.textFilterParams,
        resizable: true,
        minWidth: 450,
      },
      {
        headerName: 'Location',
        field: 'locationDescription',
        filter: 'textColumnFilterWithoutOptions',
        menuTabs: ['filterMenuTab'],
        filterParams: FilterParams.textFilterParams,
        resizable: true,
        minWidth: 120,
      },
    ],

    components: {
      textColumnFilterWithoutOptions: CustomTextFilterComponent,
      wclAddOnPopupLinkComponent: WCLAddOnPopupLinkComponent,
    },

    onGridReady: (event) => {
      this.gridApi = event.api;

      this.gridApi.setGridOption('rowData', this.rowData);

      event.api.sizeColumnsToFit();

      fromEvent(window, 'resize')
        .pipe(untilDestroyed(this), debounceTime(250))
        .subscribe(() => {
          event.api.sizeColumnsToFit();
        });
    },
  };

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.rowData = this.route.snapshot.data.data.locations;
  }
}
